/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Background_ColorInputs */

const en_background_color = /** @type {(inputs: Background_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Background Color`)
};

const es_background_color = /** @type {(inputs: Background_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color de fondo`)
};

const fr_background_color = /** @type {(inputs: Background_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur d'arrière-plan`)
};

const de_background_color = /** @type {(inputs: Background_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hintergrundfarbe`)
};

const ja_background_color = /** @type {(inputs: Background_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`背景色`)
};

const zh_background_color = /** @type {(inputs: Background_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`背景颜色`)
};

const ar_background_color = /** @type {(inputs: Background_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لون الخلفية`)
};

const id_background_color = /** @type {(inputs: Background_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warna Latar Belakang`)
};

const it_background_color = /** @type {(inputs: Background_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colore di sfondo`)
};

const ru_background_color = /** @type {(inputs: Background_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цвет фона`)
};

const pt_background_color = /** @type {(inputs: Background_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor de fundo`)
};

const ko_background_color = /** @type {(inputs: Background_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배경색`)
};

/**
* | output |
* | --- |
* | "Background Color" |
*
* @param {Background_ColorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const background_color = /** @type {((inputs?: Background_ColorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Background_ColorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_background_color(inputs)
	if (locale === "es") return es_background_color(inputs)
	if (locale === "fr") return fr_background_color(inputs)
	if (locale === "de") return de_background_color(inputs)
	if (locale === "ja") return ja_background_color(inputs)
	if (locale === "zh") return zh_background_color(inputs)
	if (locale === "ar") return ar_background_color(inputs)
	if (locale === "id") return id_background_color(inputs)
	if (locale === "it") return it_background_color(inputs)
	if (locale === "ru") return ru_background_color(inputs)
	if (locale === "pt") return pt_background_color(inputs)
	return ko_background_color(inputs)
});